import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

interface LottieAnimationProps {
    url: string;
}

export const LottieAnimation = ({ url }: LottieAnimationProps) => {
    const animationContainer = useRef(null);

    useEffect(() => {
        let anim;
        const loadAnimation = async () => {
            if (!url.endsWith(".json")) {
                console.error("The provided URL is not a .json file:", url);
                return;
            }

            try {
                const response = await fetch(url);
                const data = await response.json();

                anim = lottie.loadAnimation({
                    container: animationContainer.current,
                    renderer: "svg",
                    loop: true,
                    autoplay: true,
                    animationData: data,
                });
            } catch (error) {
                console.error("Error fetching Lottie animation:", error);
            }
        };

        loadAnimation();

        return () => {
            if (anim) {
                anim.destroy();
            }
        };
    }, [url]);

    return <div ref={animationContainer} />;
};

// Usage example
// <LottieAnimation url="https://lottie.host/2e7682ac-f046-44db-9846-6d488315c7ec/ZeypqGqVau.json" />;
